import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type NavBarCountersQueryVariables = Types.Exact<{
  lawyerId: Types.Scalars['Int']
}>

export type NavBarCountersQuery = {
  __typename?: 'Query'
  postponedLetterRequests: number
  openAppointments: number
  casesWithoutAppointments: number
  courtCaseTasks: number
}

export const NavBarCountersDocument = gql`
  query NavBarCounters($lawyerId: Int!) {
    postponedLetterRequests: countPostponedRequestsForLawyer
    openAppointments: countOpenAppointments
    casesWithoutAppointments: countCases(
      filters: {
        lawyerId: { equals: $lawyerId }
        state: { in: [Approved] }
        activeOnly: { equals: true }
        hasAppointment: { equals: false }
      }
    )
    courtCaseTasks: countCourtCases(
      filters: {
        assignedLawyerId: { equals: $lawyerId }
        state: { in: [ClientFileApproved, UpdatedByCustomer, ClientFileOpenedByLawyer] }
        archived: { equals: false }
      }
    )
  }
`
export function useNavBarCountersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<NavBarCountersQuery, NavBarCountersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<NavBarCountersQuery, NavBarCountersQueryVariables>(
    NavBarCountersDocument,
    options
  )
}
export function useNavBarCountersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    NavBarCountersQuery,
    NavBarCountersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<NavBarCountersQuery, NavBarCountersQueryVariables>(
    NavBarCountersDocument,
    options
  )
}
export type NavBarCountersQueryHookResult = ReturnType<typeof useNavBarCountersQuery>
export type NavBarCountersLazyQueryHookResult = ReturnType<typeof useNavBarCountersLazyQuery>
export type NavBarCountersQueryResult = ApolloReactCommon.QueryResult<
  NavBarCountersQuery,
  NavBarCountersQueryVariables
>
export function refetchNavBarCountersQuery(variables?: NavBarCountersQueryVariables) {
  return { query: NavBarCountersDocument, variables: variables }
}
